<template>
    <div class="dropdown" v-if="store.state.brand_settings['is_notification_enabled'] == 1 && ['admin', 'owner'].includes(store.getters.role)">
        <!--begin::Toggle-->
        <div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px">
            <div :key="componentKey" class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary">
                <span class="svg-icon svg-icon-xl svg-icon-primary" id="notifications_icon" name="notifications_icon">
                    <i class="fa fa-bell" aria-hidden="true" style="color: #B5B5C3; cursor: pointer" @click="refreshNotifications"></i>
                    {{ notificationsCounterValue }}
                </span>
                <span v-if="notificationsCounterValue > 0" class="pulse-ring"></span>
            </div>
        </div>
        <!--end::Toggle-->
        <!--begin::Dropdown-->
        <div class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            <div :key="componentKey">
            <form>
                <!--begin::Header-->
                <div class="d-flex flex-column pt-10 pb-5 bgi-size-cover bgi-no-repeat rounded-top"
                    :style="`background-image: url(/images/bg-1.jpg)`">
                    <!--begin::Title-->
                    <h4 class="d-flex flex-center rounded-top">
                        <span class="text-white">Notifications</span>
                        <!-- <span class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2">23 new</span> -->
                    </h4>
                    <!--end::Title-->
                    <!--begin::Tabs-->
                    <ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-1 px-8"
                        role="tablist" style="border-bottom: 0px !important;">

                        <!-- <li class="nav-item">
                            <a class="nav-link active show" data-toggle="tab" href="#topbar_notifications_events">Events</a>
                        </li> -->

                    </ul>
                    <!--end::Tabs-->
                </div>
                <!--end::Header-->
                <!--begin::Content-->
                <div class="tab-content">

                    <!--begin::Tabpane-->
                    <div class="tab-pane active show pb-2" id="topbar_notifications_events" role="tabpanel">
                        <!--begin::Nav-->
                        <div class="navi navi-hover scroll my-2" data-scroll="true" data-height="300"
                            data-mobile-height="200">
                            <!--begin::Item-->
                            <div v-if="notifications.length > 0">
                                <div v-for="(notify,index) in notifications.slice()" :key="index">
                                    <a class="navi-item">
                                        <div class="navi-link">
                                            <div class="navi-icon mr-2">
                                                <i :class="'flaticon2-' + notify.icon + ' ' + notify.label"></i>
                                            </div>
                                            <div class="navi-text">
                                                <div class="font-weight-bold" v-html="notify.message"></div>
                                                <div class="text-muted">{{ humanReadableTime(notify.created_at)}}</div>
                                            </div>
                                        </div>
                                    </a>
                                    <div v-if="!(index == notifications.length - 1)">
                                        <div class="separator separator-solid"></div>
                                    </div>
                                    <div v-else class="finish-notifications">
                                        <div class="finish-icon">
                                            <img
                                                class="text-center"
                                                src="/images/finish.png"
                                                alt="Finished"
                                                width="50"
                                                height="50"
                                            />
                                        </div>
                                        <div class="finish-notification">
                                            <p class="no-more-to-load">
                                                That's all your notifications from the last 30 days.
                                            </p> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="navi-item">
                                    <div class="navi-link">
                                        <div class="navi-icon mr-2">
                                            <i class="flaticon2-bell-2"></i>
                                        </div>
                                        <div class="navi-text">
                                            <div class="font-weight-bold">No notifications available</div>
                                            <div class="text-muted">No notifications available</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--end::Item-->
                        </div>
                        <div class="separator separator-solid"></div>
                            <div class="p-2 float-left">
						        <router-link :to="{ name: 'notifications' }" id="see_all_cta" name="see_all_cta" @click="closeModel">See All</router-link>
                            </div>
                            <div class="p-2 float-right">
                                <a href="#" @click="markAllAsRead" id="mark_all_as_read_cta" name="mark_all_as_read_cta">
                                    Mark all as read</a>
                            </div>
                        <!--end::Nav-->
                    </div>
                    <!--end::Tabpane-->
                </div>
                <!--end::Content-->
            </form>
            </div>
        </div>
        <!--end::Dropdown-->
    </div>

</template>

<script setup>
    import NotificationsAPIService from '@/js/api/notifications/notifications';
    import { ref, computed, onMounted } from 'vue';
    import { useStore } from 'vuex';
    import {toast} from "vue3-toastify";
    import 'vue3-toastify/dist/index.css';
    import echo from '@/js/echo'

    const store = useStore();
    const subdomain = computed(() => store.getters.brand['subdomain']);
    const notifications = ref([]);
    const notificationsCounter = ref(0);
    const isLoading = ref(true);
    const componentKey = ref(0);
    const notificationsCounterValue = computed(() => notificationsCounter.value);


    onMounted(async () => {
    if (['admin', 'owner', 'staff'].includes(store.state.role)) {
         await getNotifications();
               notificationEvent();
    }
        
    });

    // const getNotifications = () =>{
    //     NotificationsAPIService.getAll().then(response => {
    //         console.log("Notifications response:", response);
            
    //         if(response.data.hasOwnProperty("notifications")) {
    //             notifications.value = response.data.notifications;
    //             notificationsCounter.value = response.data.notificationsCounter;
    //             componentKey.value += 1;

    //                        console.log("notificationsCounter", notificationsCounter.value);
    //         }
    //     }).catch((error) => {
    //         toast.error(error);
    //     });
    // };

const getNotifications = async () => {
    isLoading.value = true;
        try {
            const response = await NotificationsAPIService.getAll();
            if (response.data.hasOwnProperty("notifications")) {
                notifications.value = response.data.notifications;
                notificationsCounter.value = response.data.notificationsCounter;
                componentKey.value++;
                isLoading.value = false;
            }
        } catch (error) {
            isLoading.value = false;
            // toast.error(error);
        }
    };

    const notificationEvent = () => {
        echo.channel('events-' + subdomain.value)
        .listen('NotificationEvent', (e) => {
        // Transform broadcast event data to match API structure
        const notificationData = {
            message: e.message,
            created_at: e.created_at,
            icon: e.icon,
            label: e.label,
            type: 'Order', 
            brand_id: store.getters.brand.id,
            show_to_user: 1,
            mark_as_read: 0
        };
        notificationsCounter.value += 1;
        notifications.value.unshift(notificationData); // Add to beginning of array
        componentKey.value += 1;
        });
        echo.channel('events-' + subdomain.value)
        .listen('GuestNotificationEvent', (e) => {
        // Transform broadcast event data to match API structure
        const notificationData = {
            message: e.message,
            created_at: e.created_at,
            icon: e.icon,
            label: e.label,
            type: 'Order', // Default type for broadcast events
            brand_id: store.getters.brand.id,
            show_to_user: 1,
            mark_as_read: 0
        };
        notificationsCounter.value += 1;
        notifications.value.unshift(notificationData);
        componentKey.value += 1;
        });
    };
    const markAllAsRead = () => {
        NotificationsAPIService.markAllAsRead().then(response => {
            if (response.data.hasOwnProperty("success")) {
                notificationsCounter.value = 0;
                console.log("All notifications marked as read:",notificationsCounter.value);
            } else if (response.data.hasOwnProperty("error")) {
                toast.error(response.data.errors);
            }
        }).catch((error) => {
            toast.error(error);
        });
    };
    const closeModel = () => {
        const dropdown = document.querySelector('.dropdown-menu');
        if (dropdown) {
            dropdown.classList.remove('show');
        }
    };
    const refreshNotifications = () => {
        getNotifications();
    };

</script>

<style scoped>
    .dropdown-menu {
        padding: 0px !important;
    }

    .font-weight-bold {
        font-weight: 700 !important;
    }

    .scroll {
        height: 300px;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .scroll::-webkit-scrollbar {
        display: none;
    }
    .no-more-to-load {
        font-size: 14px;
        line-height: 20px;
        width: 225px;
        text-align: center !important;
    }
    .finish-notification {
        display: flex;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        padding-top: 10px;
    }
    .finish-notifications {
        margin: 0px 24px;
        -webkit-box-flex: 1;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
    .finish-icon {
        text-align: center;
    }
</style>
